import { createContext, useContext } from "react";
import BasketService from "../../services/BasketService";
import { Basket } from "../../types/Basket/Basket";

export interface BasketContextType {
  basket?: Basket | null;
  setBasket: (basket: Basket | null) => void;
}
const BasketContext = createContext<BasketContextType | undefined>(undefined);

const useBasketContext = () => {
  // get the context
  const context = useContext(BasketContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error("useBasketContext was used outside of its Provider");
  }

  return context;
};

export { BasketContext, useBasketContext };
